import { Component, OnInit, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ActivatedRoute } from '@angular/router'
import { AwpPerimetroApiService } from '../../_services'
import { FortinetDetailsComponent } from '../awpDashboard/fortinetComponent/fortinetDetails.component'
import { CiscoDetailsComponent } from '../awpDashboardCisco/ciscoDetails/ciscoEdgeComponent/ciscoDetails.component'

import { OptimUiSharedModule } from '../../shared/optimus-ui-shared.module';
@Component({
  selector: 'app-sdwan-monitor',
  imports: [OptimUiSharedModule, CommonModule, FortinetDetailsComponent, CiscoDetailsComponent],
  template: `
    @if (loading()) {
      <div class="sdwan-monitor-state">
        <div class="sdwan-state-card loading">
          <div class="sdwan-state-icon pi pi-spin pi-spinner"></div>
          <div class="sdwan-state-title">Caricamento SDWAN Monitor</div>
          <div class="sdwan-state-subtitle">
            Sto verificando il frazionario <span class="sdwan-state-strong">{{ frazionario() }}</span> e selezionando il componente giusto.
          </div>
        </div>
      </div>
    }
    
    @if (!loading() && errorMessage()) {
      <div class="sdwan-monitor-state">
        <div class="sdwan-state-card error">
          <div class="sdwan-state-icon pi pi-exclamation-circle"></div>
          <div class="sdwan-state-title">Errore di caricamento</div>
          <div class="sdwan-state-subtitle">
            {{ errorMessage() }}
          </div>
        </div>
      </div>
    }
    
    @if (selectedTechnology() === 'fortinet') {
      <fortinet-details [standalone]="true" [frazionario]="frazionario()" [showFortinetDetails]="true"></fortinet-details>
    }
    @if (selectedTechnology() === 'cisco') {
      <cisco-edge [standalone]="true" [deviceUUID]="deviceUUID()" [showCiscoEdge]="true"></cisco-edge>
    }
    `,
  styleUrls: ['./sdwan-monitor.component.scss']
})
export class SdwanMonitorComponent implements OnInit {
  loading = signal(true)
  errorMessage = signal('')
  frazionario = signal<string | null>(null)
  deviceUUID = signal<string | null>(null)
  selectedTechnology = signal<'fortinet' | 'cisco' | null>(null)
  testError = false

  constructor (
    private readonly route: ActivatedRoute,
    private readonly awpPerimetroApiService: AwpPerimetroApiService
  ) {}

  ngOnInit (): void {
    this.route.queryParams.subscribe(params => {
      this.frazionario.set(params.fraz || null)
      this.testError = params.fakeError === 'true' || params.fakeError === '1'
      if (!this.frazionario()) {
        this.errorMessage.set('Parametro query "fraz" mancante.')
        this.loading.set(false)
        return
      }
      this.detectTechnology(this.frazionario())
    })
  }

  private detectTechnology (frazionario: string): void {
    this.loading.set(true)
    this.errorMessage.set('')
    this.selectedTechnology.set(null)
    this.deviceUUID.set(null)
    this.awpPerimetroApiService.Get_PerimetroAWP_byfraz(frazionario).subscribe(
      (response: any) => {
        const tech = (response?.Tecnologia || response?.technology || '').toString().toLowerCase()
        if (tech === 'fortinet') {
          this.selectedTechnology.set('fortinet')
        } else if (tech === 'cisco') {
          this.selectedTechnology.set('cisco')
          this.deviceUUID.set(response?.Cisco?.ChassisNumber || response?.Cisco?.deviceUUID)
          if (!this.deviceUUID()) {
            this.errorMessage.set('Informazioni insufficienti per visualizzare il monitor Cisco. Device UUID mancante.')
            this.loading.set(false)
            return
          }
        } else {
          this.errorMessage.set('Tecnologia non riconosciuta per questo frazionario.')
        }
        this.loading.set(false)
      },
      error => {
        this.errorMessage.set(error?.error?.message || 'Errore durante l’identificazione della tecnologia.')
        this.loading.set(false)
      }
    )
  }
}
